import {dniValidator} from './dni.validator';

/**
 * NIE validator for Spain registration number
 *
 * Translated from Java (tech-starters/validation/src/main/java/com/hopwork/validation/registration/number/NieValidator.java)
 */
export function nieValidator(value: string): boolean {
    const cleanNie = value.replace(/ /g, '');
    if (cleanNie.length !== 9) {
        return false;
    }

    const firstNieLetter = cleanNie.charAt(0);
    switch (firstNieLetter) {
        case 'X':
            return dniValidator('0' + cleanNie.substring(1));
        case 'Y':
            return dniValidator('1' + cleanNie.substring(1));
        case 'Z':
            return dniValidator('2' + cleanNie.substring(1));
    }

    return false;
}
